<template>
  <div v-if="isInitialized()">
    <ProductGrid
      :colMd="colMd"
      :colSm="colSm"
      :colXl="colXl"
      :currentItemsNumber="currentItemsNumber"
      :products="products"
      :totalItems="totalItems"
    />

    <div v-if="isInitialized() && totalItems > 0" class="catalog-load-more">
      <button
        v-if="nextPage"
        class="catalog-load-more__button uk-button uk-button-primary"
        type="button"
        :disabled="loading"
        @click="$emit('load-more')"
      >
        {{ loading ? 'Загружаем...' : 'Показать еще' }}
      </button>

      <p v-else class="catalog-load-more__status">
        Показаны все {{ totalItems }} модели
      </p>

      <p class="catalog-load-more__meta">
        Показано {{ products.length }} из {{ totalItems }}
      </p>
    </div>

    <p v-if="products.length === 0" class="product-grid-filter__empty">
      К сожалению, товаров с заданными фильтрами не найдено. Попробуйте выбрать другие параметры фильтра.
    </p>
  </div>
</template>

<script>
import ProductGrid from "./product_grid.vue";

export default {
  emits: ['load-more'],
  props: ['colSm', 'colMd', 'colXl', 'currentItemsNumber', 'loading', 'nextPage', 'products', 'totalItems'],
  components: {
    ProductGrid
  },
  methods: {
    isInitialized: function() {
      return (this.totalItems !== null)
    },
  }
};

</script>
